import { gql } from "apollo-boost";

export const GET_ORDERGROUPS = gql`
query OrderGroups($where: OrderGroupWhereInput!, $orderBy: OrderByInput, $skip: Int, $limit: Int) {
    orderGroups(where: $where, orderBy: $orderBy, skip: $skip, limit: $limit) {
      total
      data {
        customerLastName
        village
        district
        province
        id
        amount
        currency
        payment
        receivedMoney
        sumPrice
        sumPriceBaht
        sumPriceUsd
        rateUsd
        rateBaht
        totalPrice
        staff
        status
        staffLastname
        code
        createdAt
        updatedAt
        customerName
        paymentDate
        costTitle
        phone
        commissionTotal
        commissionPlatforms
        discountType
        discount
        discountManual
        cash
        transfer
        debt
        taxes {
          taxStatus
          tax
          taxType
          priceBeforeTax
          taxAmount
        }
        createdBy {
          id
          image
          firstName
          lastName
          phone
          role
          staffCode
        }
        shop {
          id
          address {
            village
            province
            district
          }
          image
        }
        orders {
          id
          amount
          amountFree
          phone
          productName
          currency
          originPrice
          price
          totalPrice
          totalPriceBaht
          totalPriceUsd
          type
          isPaymented
          isDeleted
          note
          createdAt
          updatedAt
          sortId
          stock {
            id
            currency
            price
            unit
            unitId {
              name
            }
            category {
              name
            }
            survivalId {
              survivalNumber
            }
          }
          options {
            name
            price
          }
        }
        userConfirm {
          name
        }
      }
    }
  }
`;

export const GET_ORDER_GROUPS_V2 = gql`
query OrderGroupsV2($where: OrderGroupWhereInput!, $orderBy: OrderByInput, $skip: Int, $limit: Int) {
    orderGroupsV2(where: $where, orderBy: $orderBy, skip: $skip, limit: $limit) {
      total
      data {
        checkBillDate
        customerLastName
        village
        district
        province
        id
        amount
        currency
        payment
        receivedMoney
        sumPrice
        sumPriceBaht
        sumPriceUsd
        rateUsd
        rateBaht
        totalPrice
        commissionTotal
        commissionPlatforms
        staff
        status
        staffLastname
        type
        code
        transfer
        cash
        debt
        productionStatus
        taxes {
          taxStatus
          tax
          taxType
          priceBeforeTax
          taxAmount
        }
        isPaymented
        createdAt
        updatedAt
        createdBy {
          id
          image
          firstName
          lastName
          phone
          role
          staffCode
        }
        customerName
        phone
        discount
        discountManual
        discountType
        shippingCost
        addressCf
        costTitle
        logistic
        destinationLogistic 
        deliveryMethod
        note
        userConfirm {
          name
          lastname
          phone
          userCode
          address {
            district
            province
            village
          }
          userType {
            id
            isOpen
            name
          }
        }
        shop {
          id
          address {
            village
            province
            district
          }
          image
        }
        orders {
          id
          amount
          amountFree
          phone
          productName
          currency
          originPrice
          price
          totalPrice
          totalPriceBaht
          totalPriceUsd
          type
          isDeleted
          note
          createdAt
          updatedAt
          sortId
          productVariant{
            id
            # name
            price
            originPrice
            barCode
            note
            image
            imageString
          }
          options {
            name
            price
          }
          stock {
            id
            currency
            image
            price
            unit
            unitId {
              name
            }
            categoryName
            category {
              name
            }
            survivalId {
              survivalNumber
            }
            size
            dimension {
              length
              width
              height
              weight
            }
          }
          children {
            id
            stockOptionItem
            tag
            amount
            price
            stock {
              name
              amount
              price
              size
              unitId {
                id
                name
              }
              dimension {
                length
                width
                height
                weight
              }
              currency
            }
            code
            type
            platform
            status
            currency
            tag
            productName
            originPrice
            price
            amount
            volume
            rate
            totalPrice
            convertPrice
          }
        }
      }
    }
  }
`


export const GET_ORDERGROUP = gql`
query OrderGroup($where: OrderGroupWhereInputOne!) {
  orderGroup(where: $where) {
    id
    amount
    shop {
      id
      name
      phone
    }
    code
    status
    totalPrice
    sumPrice
    sumPriceBaht
    sumPriceUsd
    receivedMoney
    change
    commissionTotal
    commissionPlatforms
    rateBaht
    rateUsd
    currency
    addressCf
    costTitle
    discount
    discountType
    discountManual
    payment
    paymentDate
    shippingCost
    note
    taxes {
      taxStatus
      tax
      taxType
      priceBeforeTax
      taxAmount
    }
    addressCf
    createdBy {
      id
      image
      firstName
      lastName
      phone
      role
      staffCode
    }
    logistic
    deliveryMethod
    orders {
      id
      amount
      amountFree
      phone
      productName
      stock {
        id
        price
        originPrice
        currency
        size
        amount
        image
        name
        unit
        hasVariant
        unitId {
          id
          name
        }
        survivalId {
          survivalNumber
        }
        dimension {
          length
          width
          height
          weight
        }
      }
      currency
      price
      originPrice
      totalPrice
      totalPriceBaht
      totalPriceUsd
      cfName
      status
      payment
      type
      isPaymented
      sortId
      isDeleted
      note
      children {
        id
        stockOptionItem
        tag
        amount
        price
        stock {
          id
          name
          amount
          price
          size
          unitId {
            id
            name
          }
          dimension {
            length
            width
            height
            weight
          }
          currency
        }
        code
        type
        platform
        status
        currency
        tag
        productName
        originPrice
        price
        amount
        volume
        rate
        totalPrice
        convertPrice
      }
      options {
        name
        price
      }
    }
    userConfirm {
      id
      name
      lastname
      phone
      userCode
      address {
        district
        province
        village
      }
    }
  }
}
`

export const GET_ORDERGROUPV2 = gql`
query OrderGroupV2($where: OrderGroupWhereInputOne!) {
  orderGroupV2(where: $where) {
    id
    amount
    shop {
      id
      name
      phone
    }
    code
    status
    totalPrice
    sumPrice
    sumPriceBaht
    sumPriceUsd
    currency
    addressCf
    costTitle
    commissionTotal
    commissionPlatforms
    discount
    discountManual
    payment
    paymentDate
    shippingCost
    taxes {
      taxStatus
      tax
      taxType
      priceBeforeTax
      taxAmount
    }
    addressCf
    createdBy {
      id
      image
      firstName
      lastName
      phone
      role
      staffCode
    }
    logistic
    deliveryMethod
    orders {
      id
      amount
      amountFree
      phone
      productName
      stock {
        id
        price
        originPrice
        currency
        size
        amount
        image
        name
        unit
        unitId {
          id
          name
        }
        survivalId {
          survivalNumber
        }
        dimension {
          length
          width
          height
          weight
        }
      }
      
      currency
      price
      originPrice
      totalPrice
      totalPriceBaht
      totalPriceUsd
      cfName
      status
      payment
      type
      isPaymented
      sortId
      isDeleted
      note
      children {
        id
        stockOptionItem
        stock {
          name
          amount
          price
          size
          unitId {
            id
            name
          }
          dimension {
            length
            width
          unitId {
            id
            name
          }
            height
            height
            weight
          }
          currency
        }
        code
        type
        platform
        code
        type
        platform
        status
        currency
        tag
        productName
        originPrice
        price
        amount
        volume
        rate
        totalPrice
        convertPrice
      }
      options {
        name
        price
      }
    }
    userConfirm {
      id
      name
      lastname
      phone
      userCode
      address {
        district
        province
        village
      }
    }
  }
}
`
export const GET_GEN_CODE_ORDER_GROUP = gql`
query OrderGroups($where: OrderGroupWhereInput!, $orderBy: OrderByInput, $skip: Int, $limit: Int) {
    orderGroups(where: $where, orderBy: $orderBy, skip: $skip, limit: $limit) {
      total
    }
  }
`

export const GENERATE_CODE = gql`
  query GenerateCode($where: OrderGroupWhereInput!) {
    generateCode(where: $where) {
      status
      msg
      tag
    }
  }
`;

export const GET_INDEBTED = gql`
query Indebteds($where: OrderGroupWhereInput!, $limit: Int, $orderBy: OrderByInput, $skip: Int) {
  indebteds(where: $where, limit: $limit, orderBy: $orderBy, skip: $skip) {
    total
    totalAmount
    totalSumPrice
    data {
      _id
      customerId
      customerName
      customerLastName
      phone
      village
      district
      province
      billQty
      amount
      sumPrice
    }
  }
}
`

export const GET_TOTAL_ORDERGROUP_STATUS = gql`
query TotalOrdergroupStatusFromSP($where: OrderGroupWhereInput!) {
  totalOrdergroupStatusFromSP(where: $where) {
    total
    productionStatus
  }
}
`

export const UPDATE_PRODUCTION_STATUS = gql`
  mutation UpdateProductionStatus($where: OrderGroupWhereInputOne!, $data: ProductionStatusInput!) {
    updateProductionStatus(where: $where, data: $data) {
      id
      productionStatus
      productionHistory {
        status
        note
        createdAt
      }
    }
  }
`;
export const UPDATE_PRODUCTION_STATUS_MANY = gql`
 mutation UpdateProductionStatusMany($data: ProductionStatusInput!, $where: OrderGroupWhereInputMany!) {
  updateProductionStatusMany(data: $data, where: $where) {
    id
  }
}
`;
